import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../shared/interface/wrap-api-response.interface';
import {
  LoginRequest,
  LoginResult,
  LogoutResult,
  RefreshRequest,
} from './interfaces/login.interface';
import {
  PasswordRecoveryRequest,
  PasswordRecoveryRequestResult,
  PasswordRecoveryReset,
  PasswordRecoveryResetResult,
  PasswordRecoveryVerify,
  PasswordRecoveryVerifyResult,
} from './interfaces/password-recovery.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private services = environment.SERVICES;

  /** Web portal login (SUPERADMIN, ADMIN). */
  public login(payload: LoginRequest): Observable<ApiResponse<LoginResult>> {
    return this.http.post<ApiResponse<LoginResult>>(
      environment.API_DOMAIN + this.services.LOGIN,
      payload,
    );
  }

  /** Closes the session of the current access token (sent by authInterceptor). */
  public logout(): Observable<ApiResponse<LogoutResult>> {
    return this.http.post<ApiResponse<LogoutResult>>(
      environment.API_DOMAIN + this.services.LOGOUT,
      {},
    );
  }

  /** Rotates the token pair; the old refresh token stops working. */
  public refresh(payload: RefreshRequest): Observable<ApiResponse<LoginResult>> {
    return this.http.post<ApiResponse<LoginResult>>(
      environment.API_DOMAIN + this.services.REFRESH,
      payload,
    );
  }

  public requestPasswordRecovery(
    payload: PasswordRecoveryRequest,
  ): Observable<ApiResponse<PasswordRecoveryRequestResult>> {
    return this.http.post<ApiResponse<PasswordRecoveryRequestResult>>(
      environment.API_DOMAIN + this.services.PASSWORD_RECOVERY_REQUEST,
      payload,
    );
  }

  public verifyPasswordRecovery(
    payload: PasswordRecoveryVerify,
  ): Observable<ApiResponse<PasswordRecoveryVerifyResult>> {
    return this.http.post<ApiResponse<PasswordRecoveryVerifyResult>>(
      environment.API_DOMAIN + this.services.PASSWORD_RECOVERY_VERIFY,
      payload,
    );
  }

  public resetPassword(
    payload: PasswordRecoveryReset,
  ): Observable<ApiResponse<PasswordRecoveryResetResult>> {
    return this.http.post<ApiResponse<PasswordRecoveryResetResult>>(
      environment.API_DOMAIN + this.services.PASSWORD_RECOVERY_RESET,
      payload,
    );
  }
}
